'use strict';

angular.module('app')
  .controller('CheckoutDR', function ($scope, $timeout, $location, $window, $routeParams, config, checkoutDrService, Auth, localStorageService, diviacLocalStorage, GTM, currentDO, info, gettextCatalog, paymentService, $rootScope, checkoutService, utils) {
    var vm = this,
      roomPrice,
      mandatoryItemsPrice,
      ecomerceProduct,
      gaClientId;

    if (window.ga) {
      window.ga(function (tracker) {
        gaClientId = tracker.get('clientId');
      });
    }

    vm.rentalEquipmentId = utils.getInclusionGroupsId('Rental equipment');
    vm.dcExtrasId = utils.getInclusionGroupsId('DC Extras & Surcharge');

    vm.order = paymentService.prefillUser();

    vm.countryList = info.countryList;
    vm.selectedOptions = [];
    vm.pageParams = { location: $routeParams.location, slug: $routeParams.slug };
    vm.info = currentDO;
    vm.pageUrl = utils.createURL('dr_page', $routeParams);
    vm.isPackage = !vm.info.isDynamicPackages;
    vm.minNightsPlaceholder = gettextCatalog.getPlural(vm.info.minimalDays, 'min {{ qty }} night stay', 'min {{ qty }} nights stay', {
      qty: vm.info.minimalDays,
    });
    vm.roomsAndGuests = config.roomsAndGuests;
    vm.showPrices = showPrices;
    vm.formattedRoomsText = utils.formattedRoomsText;
    vm.setTransferIcon = utils.setTransferIcon;
    vm.updateRoom = updateRoom;
    vm.updateDate = updateDate;
    vm.selectProduct = selectProduct;
    vm.firstStepOpen = firstStepOpen;
    vm.checkout = checkoutDrService;
    vm.additionalPriceText = additionalPriceText;
    vm.createOrder = createOrder;
    vm.createAccount = createAccount;
    vm.saveOrderToStorage = saveOrderToStorage;
    vm.checkout = checkout;
    vm.setLimit = checkoutDrService.setLimit;
    vm.isAffiliate = Auth.isAffiliate();
    vm.checkRequired = checkoutService.checkRequired;
    vm.stepChanged = stepChanged;
    vm.getTextFromInfo = utils.getTextFromInfo;

    vm.getUserAccount = paymentService.getUserAccount;
    vm.getAffiliate = paymentService.getAffiliate;
    vm.getAffiliateCompaign = paymentService.getAffiliateCompaign;
    vm.setUserAccount = setUserAccount;

    vm.updateUserCredentials = updateUserCredentials;

    vm.cancellationDate = moment().add(4, 'day').toDate();
    vm.selectDurations = Array.apply(null, { length: 21 }).map(function (value, index) { return index + 1; }); // create array from 1 to 21
    vm.showPaymentForm = false;
    vm.isLastMinute = true;
    vm.isLastMinuteBooking = utils.isLastMinuteBooking;
    vm.saveOrder = saveOrder;
    vm.paymentMethod = null;
    vm.usdTotalPrice = '';
    vm.paymentProcessor = diviacLocalStorage.get('paymentProcessor') || paymentService.STRIPE_PP;
    vm.isNewOption = sessionStorage.getItem('newOption');
    vm.experimentId = window.google_optimize && window.google_optimize.get(info.experimentIdDr);
    vm.experimentIsActive = vm.experimentId === '1';
    vm.showCouponForm = false;
    vm.applyVoucher = applyVoucher;
    vm.dataForDueNow = false;
    vm.removeVoucher = removeVoucher;

    vm.steps = [
      {
        text: gettextCatalog.getString('Select your package'),
        shortText: gettextCatalog.getString('Package'),
      },
      {
        text: gettextCatalog.getString('Add Extras'),
        shortText: gettextCatalog.getString('Extras'),
      },
      {
        text: gettextCatalog.getString('Review & book'),
        shortText: gettextCatalog.getString('Review'),
      }
    ];

    var savedOrder = diviacLocalStorage.get('drOrder'),
      affiliate = utils.getAffiliateId();

    if (savedOrder) {
      angular.extend(vm.order, savedOrder.order);
      vm.diversNumber = savedOrder.diversNumber;
      vm.selectedOptions = savedOrder.selectedOptions;
      vm.divesPrices = savedOrder.divesPrices;
      roomPrice = savedOrder.roomPrice;

      diviacLocalStorage.remove('drOrder');
    }


    if (localStorageService.get('order_uuid') && localStorageService.get('referrer') && !vm.isNewOption) {
      vm.orderEdit = true;
      vm.order.referrer = localStorageService.get('referrer');
      vm.order.uuid = localStorageService.get('order_uuid');
    }

    window.onpopstate = function () {
      if (vm.step === 1 || vm.step === 4) {
        history.back();
        window.onpopstate = undefined;
      } else if (vm.step === 4 || vm.step === 'payment-issue') {
        firstStepOpen();
      } else {
        vm.step = vm.step - 1 || 1;

        if (vm.step === 1) {
          firstStepOpen();
        }

        if (vm.step !== 3) {
          paymentService.destroyElements();
          // vm.paymentMethod = null;
        }

        history.pushState('back', null, null);

        $timeout($rootScope.scrollTo('.shop-banner', 250));
      }

      $scope.$apply();
    };

    init();

    function init() {
      vm.filter = {
        from: diviacLocalStorage.get('date') ?  diviacLocalStorage.get('date')[0] : moment().add(30, 'day').format('YYYY-MM-DD'),
        roomSelected: 2,
        duration: diviacLocalStorage.get('duration') || 7,
      };

      if (vm.filter.duration < vm.info.minimalDays) {
        vm.filter.duration = vm.info.minimalDays;
      }

      // Get insurance
      if (vm.info.includeFreeDiveInsurance) {
        checkoutService.getInsurances().then(function (data) {
          vm.insurances = data;
          if (vm.insurances && vm.insurances[0]) {
            vm.insuranceTooltip = gettextCatalog.getString('We have partnered with DAN - Divers Alert Network - to offer you free dive accident insurance for the duration of your trip (valid for bookings with a value of >USD {{ price }} per person)', { price: vm.insurances[0].limitPrice });
          }
        });
      }

      // remove disabled durations;
      vm.selectDurations.splice(0, vm.info.minimalDays - 1);

      var selectedRoom = diviacLocalStorage.get('roomParams');

      if (selectedRoom) {
        if (selectedRoom.id === 'auto') {
          vm.filter.roomSelected = 'auto';
          vm.roomsAndGuests[2] = selectedRoom;
        } else {
          vm.filter.roomSelected = selectedRoom.id;
        }
      }

      var roomFilters = utils.setRoomParams(vm.filter.roomSelected, vm.filter);

      vm.filterParams = roomFilters.filterParams;
      vm.roomParams = roomFilters.roomParams;

      var query = $location.search();

      if (query && (query.rate || query.packages) && query.room) {
        selectProduct(query);
        $location.search({});
      } else if (savedOrder) {
        getAdditionalPricingInfo();
        createOrder();
      } else {
        getRooms();
      }
    }

    function getRooms() {
      vm.loader = true;

      return checkoutDrService.getResortMealPlans().then(function (data) {
        vm.mealPlanDescriptions = data.mealPlanDescriptions;

        showPrices().then(function () {
          vm.loader = false;
          vm.step = 1;
        });
      });
    }

    function updateInsurances() {
      if (!vm.order.priceForPackage) return;
      vm.paidInsurances = false;
      _.each(vm.insurances, function (insurance) {
        insurance.isFree = $rootScope.setValue(vm.order.priceForPackage / vm.filterParams.totalGuests, vm.info.currency, true, insurance.limitPriceCurrency) > +insurance.limitPrice;
        if (!insurance.isFree) {
          // show insurance only if its free;
          insurance.qty = 0;
          vm.paidInsurances = true;
        }
      });
    }

    function selectProduct(selectedItem) {
      vm.loader = true;

      if (!vm.selectedRoomText) {
        vm.selectedRoomText = utils.formattedRoomsText(vm.roomParams);
      }

      if (selectedItem.packages) {
        vm.filterParams.packages = selectedItem.packages;
        vm.filterParams.rate = undefined;
      } else {
        vm.filterParams.rate = selectedItem.rate;
        vm.filterParams.packages = undefined;
      }

      if (!vm.filterParams.guests_split) {
        vm.filterParams.guests_split = (vm.roomParams && vm.roomParams.details) || undefined;
      }

      checkoutDrService.getPricingDetails(selectedItem.room, vm.filterParams).then(function (data) {
        var rate = vm.isPackage ? _.find(data[0].rates, {mealPlan: +selectedItem.mealPlan}) : data[0].rates[0],
          numberOfDives = data[0].divesAmount || (vm.divePrices && vm.divePrices.isTwoTank ? 2 : 1),
          priceForPackage = +rate.ratePrice;

        angular.extend(vm.order, {
          roomTitle: data[0].title,
          rate: rate,
          from: vm.filter.from,
          to: vm.filter.to,
          roomParams: vm.roomParams,
          shop: vm.info.id,
          freeCancellationDays: data[0].freeCancellationDays,
          duration: vm.filter.duration,
          diversNonDiversText: vm.selectedRoomText,
          roomPrice: priceForPackage,
          priceForPackage: _.clone(priceForPackage),
          packageDiveKind: data[0].packageDiveKind,
          packageDiveKindText: data[0].packageDiveKind && utils.getTextFromInfo(data[0].packageDiveKind, 'booking', 'DIVES_IN_PACKAGE').toLowerCase(),
          diveType: utils.getTextFromInfo(data[0].diveType, 'shop', 'DIVE_TYPE').toLowerCase(),
        });

        updateInsurances();

        checkoutDrService.getInclusions(
          { date_0: vm.filter.from,
            date_1: vm.filter.to,
            packages: vm.filterParams.packages,
            rate: vm.filterParams.rate,
          },
          {
            divers: vm.filterParams.divers,
            nonDivers: vm.filterParams.nonDivers,
            students: vm.filterParams.students,
            numberOfDives: numberOfDives,
            duration: vm.order.duration,
            rooms: vm.roomParams.rooms,
          })
          .then(function (incl) {
            vm.inclusions = incl.groupedInclusions;

            vm.resortInclusions = {};

            vm.sectionWithoutMandatory = {};

            _.each(vm.inclusions, function (val, key) {
              vm.sectionWithoutMandatory[key] = _.filter(val, function (v) {
                return !v.isMandatory && !v.isIncluded;
              });

              if (vm.rentalEquipmentId !== +key && vm.dcExtrasId !== +key) {
                var belongsToObject = _.find(info.inclusionGroups, { id: +key });

                if (belongsToObject) {
                  vm.resortInclusions[key] =  {
                    title: belongsToObject.title,
                    order: belongsToObject.order,
                    isTransfer: belongsToObject.unique_identifier === 'Transfers',
                    key: key,
                    data: val,
                  };
                }
              }
            });

            vm.allInclusions = data.inclusions;

            roomPrice = _.clone(vm.order.roomPrice);

            getAdditionalPricingInfo().then(function () {
              var maxDives = vm.divePrices.maxPreorder * (vm.filter.duration - 1);
              if (maxDives === 0 || maxDives >= 100 ) {maxDives = 100; }
              vm.diversNumber = Array.apply(null, Array(vm.roomParams.divers)).map(function (x, i) {
                return {
                  key: i + 1,
                  divesIncluded: numberOfDives,
                  numberOfDives: numberOfDives,
                  isTwoTank: vm.divePrices.isTwoTank,
                  maxPreorder: maxDives,
                };
              });

              vm.studentsNumber = Array.apply(null, Array(vm.roomParams.students)).map(function (x, i) {
                return {
                  key: i + 1,
                  divesIncluded: numberOfDives,
                  numberOfDives: numberOfDives,
                  isTwoTank: vm.divePrices.isTwoTank,
                  maxPreorder: maxDives,
                };
              });

              vm.nonDiversNumber = Array.apply(null, Array(vm.roomParams.nonDivers)).map(function (x, i) {
                return {
                  key: i + 1,
                  divesIncluded: numberOfDives,
                  numberOfDives: numberOfDives,
                  isTwoTank: vm.divePrices.isTwoTank,
                  maxPreorder: maxDives,
                };
              });


              vm.loader = false;
              vm.step = 2;

              var cartValue = $rootScope.setValue(roomPrice, vm.info.currency, true, 'USD');

              GTM.variables({'checkout_cart_value': cartValue});

              GTM.products('checkout_step_extra', {
                currencyCode: vm.info.currency,
                actionField: {step: 'Extras'},
                products: [{
                  variant: vm.order.roomTitle + ' ' + rate.title,
                  id: vm.info.id,
                  price: cartValue,
                  brand: 'Independent',
                  name: vm.info.title,
                  category: 'Dive Resort',
                  quantity: 1,
                }],
              });
            });
          });
      }).catch(firstStepOpen);
    }

    function getAdditionalPricingInfo() {
      checkoutDrService.getDiveCourses().then(function (val) {
        vm.optionsCurrency = val.length ? val[0].currency : vm.info.currency;
        vm.diverCoursesList = _.filter(val, function (course) {
          return course.isDiverApplicable && course.pricing && course.pricing.priceGross > 0;
        });
        vm.nonDiverCoursesList = _.filter(val, function (course) {
          return course.isNondiverApplicable && course.pricing && course.pricing.priceGross > 0;
        });
        vm.studentCoursesList = _.filter(val, function (course) {
          return course.isStudentApplicable && course.pricing && course.pricing.priceGross > 0;
        });
      });

      return checkoutDrService.getDivesPricing().then(function (divePrices) {
        vm.divePrices = divePrices;
        return vm.divePrices;
      });
    }

    function firstStepOpen() {
      paymentService.destroyElements();
      // vm.paymentMethod = null;
      if (!vm.prices) {
        getRooms();
      } else {
        vm.step = 1;
      }
    }

    function updateDate(type) {
      if (type === 'add') {
        vm.filter.from = moment(vm.filter.from).add(1, 'days').format('YYYY-MM-DD');
      } else {
        vm.filter.from = moment(vm.filter.from).subtract(1, 'days').format('YYYY-MM-DD');
      }

      $scope.$apply();

      showPrices();
    }

    function triggerFields(isCalendar) {
      if (!vm.filter.from) {
        if (!isCalendar) {
          document.getElementById('from_date').click();
        }
        return false;
      } else if (!vm.filter.duration) {
        $timeout(function () {
          document.querySelector('#duration  .selectize-input').click();
        });

        return false;
      } else if (!vm.filter.roomSelected) {
        $timeout(function () {
          document.querySelector('#guests-and-rooms  .selectize-input').click();
        });

        return false;
      }

      return true;
    }

    function showPrices(isCalendar) {
      if (triggerFields(isCalendar) === false) {
        return;
      }

      vm.triggerCalendar = !vm.triggerCalendar;
      vm.pricesLoading = true;

      if (vm.filter.roomSelected === 'more') {
        vm.filter.roomSelected = 2;
      }

      var roomFilters = utils.setRoomParams(vm.filter.roomSelected, vm.filter);
      vm.filterParams = roomFilters.filterParams;
      vm.roomParams = roomFilters.roomParams;

      vm.filterParams.guests_split = _.get(vm.roomParams, 'details', [{
        divers: 2,
        students: 0,
        nonDivers: 0,
      }]);

      checkoutDrService.getPackagesData(vm.filterParams).then(function (pricesData) {
        vm.pricesData = pricesData;
      });

      return checkoutDrService.getResortProducts(vm.filterParams, vm.info.currency).then(function (val) {
        vm.prices = val;
        vm.totalDivers = vm.filterParams.divers;

        vm.selectedRoomText = utils.formattedRoomsText(vm.roomParams);

        vm.pricesLoading = false;

        var products = [];

        _.each(vm.prices, function (val) {
          _.each(val.rates, function (v) {
            products.push({
              variant: v.title,
              id: vm.info.id,
              price: $rootScope.setValue(v.ratePrice, vm.info.currency, true, 'USD'),
              name: vm.info.title,
              category: 'Dive Resort',
              quantity: 1,
            });
          });
        });

        GTM.products('checkout_step_package', {
          checkout: {
            actionField: {
              step: 'Package',
            },
            currencyCode: vm.info.currency,
            products: products,
          },
        });

        return val;
      });
    }

    function updateRoom(data) {
      var room = utils.selectRooms(data, vm.roomsAndGuests, vm.filter.roomSelected);
      vm.filter.roomSelected = room.filter;
      vm.roomsAndGuests = room.roomsAndGuests;

      showPrices();
    }

    function additionalPriceText() {
      vm.order.roomPrice = roomPrice;
      vm.order.priceForPackage = _.clone(roomPrice);
      vm.divesPrices = 0;
      vm.mandatorySurchargesPrice = 0;
      vm.mandatorySurchargesGrossPrice = 0;
      mandatoryItemsPrice = 0;
      vm.order.items = [];
      vm.selectedOptions = [];
      vm.mandatorySurcharges = [];
      vm.studentsCourse;
      vm.transfers = [];
      vm.selectedRental = [];
      vm.selectedExtras = [];

      var totalNumberOfDives = _.reduce(vm.diversNumber, function (acc, val) {
        return acc + val.numberOfDives;
      }, 0);

      vm.totalNumberOfDives = totalNumberOfDives;

      _.each(vm.diversNumber, function (diver) {
        if (!vm.isPackage) {
          var newPrice = checkoutDrService.additionalPriceText(diver, vm.divePrices, vm.info.currency);
          if (newPrice.add) {
            vm.divesPrices += newPrice.price;
            vm.order.roomPrice += newPrice.price;
            vm.order.priceForPackage += newPrice.price;
            updateInsurances();
          } else {
            vm.divesPrices -= newPrice.price;
            vm.order.roomPrice -= newPrice.price;
            vm.order.priceForPackage -= newPrice.price;
            updateInsurances();
          }

          diver.additionalText = newPrice.text;
          diver.currentPrice = newPrice.price;

          vm.order.items.push(newPrice.pricingObject);

          if (newPrice.additionalPricingObject) {
            vm.order.items.push(newPrice.additionalPricingObject);
          }
        }

        diver.selectedCourses = [];

        _.each(vm.inclusions[vm.rentalEquipmentId], function (course) {
          addItems(course, 'rental', true);
        });
        _.each(vm.inclusions[vm.dcExtrasId], function (course) {
          addItems(course, 'extras', true);
        });
        _.each(vm.diverCoursesList, function (course) {
          addItems(course, 'courses');
        });

        function addItems(course, type, dcItems) {
          var diverCourse = diver[type] && diver[type][course.pricingId],
            qty = diverCourse && diverCourse.qty;

          if (qty) {
            var c = _.cloneDeep(course);
            c.qty = qty;
            c.isDiveCenterItem = dcItems;

            if (c.isIncluded) {
              c.price = 0;
              c.priceGross = 0;
            }

            if (type === 'courses') {
              c.isCourse = true;
            }

            diver.selectedCourses.push(c);
            vm.selectedOptions.push(c);

            if (c.payedInAdvance !== false && !c.isMandatory) {
              vm.order.roomPrice += qty * c.priceGross;
            } else if (c.isMandatory && c.payedInAdvance !== false) {
              mandatoryItemsPrice += qty * c.priceGross;
            }

            var obj = {
              diverNumber: diver.key,
              guestType: 10,
              pricing: course.pricingId,
              quantity: qty,
            };

            vm.order.items.push(obj);
          }
        }
      });

      _.each(vm.nonDiversNumber, function (nonDiver) {
        nonDiver.selectedCourses = [];

        _.each(vm.nonDiverCoursesList, function (course) {
          var nonDiverCourse = nonDiver.courses && nonDiver.courses[course.pricingId],
            qty = nonDiverCourse && nonDiverCourse.qty;

          if (qty) {
            vm.order.roomPrice += qty * course.priceGross;

            course.qty = qty;

            nonDiver.selectedCourses.push(course);

            vm.selectedOptions.push(_.cloneDeep(course));

            var obj = {
              guestType: 20,
              diverNumber: nonDiver.key,
              pricing: course.pricingId,
              quantity: qty,
            };

            vm.order.items.push(obj);
          }
        });
      });

      _.each(vm.studentsNumber, function (student) {
        student.selectedCourses = [];

        _.each(vm.studentCoursesList, function (course) {
          var qty = 1;

          if (qty) {
            var c = _.clone(course);
            c.qty = qty;
            c.isIncluded = true;
            student.selectedCourses.push(c);
            vm.studentsCourse = c;

            var obj = {
              guestType: 40,
              diverNumber: student.key,
              pricing: c.pricingId,
              quantity: qty,
            };

            vm.order.items.push(obj);
          }
        });
      });

      _.each(vm.inclusions, function (val) {
        _.each(val, function (v) {
          if (!utils.isBelongsTo(v.belongsTo, 'DC Extras & Surcharge') && !utils.isBelongsTo(v.belongsTo, 'Rental equipment')) {
            if (v.isIncluded || v.isMandatory) {
              v.qty = checkoutDrService.setLimit(v, vm.totalNumberOfDives, vm.order.duration, vm.roomParams.rooms, vm.filterParams.totalGuests, vm.filterParams.divers, vm.filterParams.students, vm.filterParams.nonDivers);
              // var payedPer = +v.payedPer;
              // if (payedPer === 0 || payedPer === 10 || payedPer === 60 || payedPer === 55) {
              //     v.qty *= vm.filterParams.totalGuests;
              // }
            }

            if (v.qty) {
              // var price = v.qty * v.price;
              if (v.isIncluded) {
                v.price = 0;
                v.priceGross = 0;
              }

              if (utils.isBelongsTo(v.belongsTo, 'Transfers')) {
                v.isTransfer = true;
                vm.transfers.push(v);
              }

              if (v.payedInAdvance !== false && !v.isMandatory) {
                vm.order.roomPrice += v.qty * v.priceGross;
              } else if (v.isMandatory && v.payedInAdvance !== false) {
                mandatoryItemsPrice += v.qty * v.priceGross;
              }

              vm.selectedOptions.push(v);

              // if (+v.section !== 30) {
              //     // vm.order.roomPrice += price;
              //     vm.selectedOptions.push(v);
              // } else if (+v.section === 30){
              //     vm.mandatorySurcharges.push(v);
              //     vm.mandatorySurchargesGrossPrice += v.qty * v.priceGross;
              // }

              vm.order.items.push({
                pricing: v.pricingId,
                quantity: v.qty,
              });
            }
          }
        });
      });

      _.each(vm.insurances, function (val) {
        if (val.qty) {
          vm.order.items.push({
            pricing: val.prices[0].id,
            quantity: val.qty,
          });
          var price = $rootScope.setValue(val.prices[0].priceConverted, val.prices[0].priceConvertedCurrency, true, vm.info.currency);
          vm.selectedOptions.push({
            title: val.title,
            qty: val.qty,
            priceGross: val.isFree ? 0 : price,
            isIncluded: val.isFree,
            currency: vm.info.currency,
            isInsurance: true,
          });

          if (!val.isFree) {
            vm.order.roomPrice += val.qty * price;
          }
        }
      });
    }

    function prepareDataForDueNow() {
      var data = _.cloneDeep(vm.order);

      if (!data.items) { data.items = []; }

      if (vm.isPackage) {
        data.items = data.items.concat(data.rate.ids);
      } else if (_.isArray(vm.filterParams.guests)) {
        _.each(vm.filterParams.guests, function (v) {
          _.each(data.rate.pricesData[v], function (val) {
            data.items.push({
              pricing: val,
              quantity: v,
            });
          });
        });
      } else {
        _.each(data.rate.pricesData[vm.filterParams.guests], function (val) {
          data.items.push({
            pricing: val,
            quantity: vm.filterParams.guests,
          });
        });
      }

      data.dateTo = moment(data.to).format('YYYY-MM-DDThh:mm');
      data.dateFrom = moment(data.from).format('YYYY-MM-DDThh:mm');
      data.paymentProvider = vm.paymentProcessor;

      return data;
    }

    function createOrder() {
      vm.loader = true;

      if (!vm.dataForDueNow) {
        vm.dataForDueNow = prepareDataForDueNow();
      }
      
      // apply coupon on due
      if (vm.appliedVoucher) {
        vm.dataForDueNow.discountCoupon = vm.appliedVoucher.id;
      } else {
        vm.dataForDueNow.discountCoupon = undefined;
      }

      checkoutService.getDue(vm.dataForDueNow).then(function (res) {
        vm.order.items = vm.dataForDueNow.items;
        vm.due = res;

        // if discount is applied add it to the order
        if (res.appliedCoupon) {
          vm.order.discountCoupon = res.appliedCoupon.id;
        }

        vm.cancellation = {
          isCustomCancellation: res.shopData.isCustomCancellation,
          customCancellationText: res.shopData.customCancellationText,
          policy: res.shopData.cancellationPolicy,
          milestones: res.shopData.cancellationMilestones,
          policyText: _.find(info.shop.CANCELLATION_POLICY, function (val) {
            return val[0] === res.shopData.cancellationPolicy;
          }),
          freeCancellationDays: vm.order.freeCancellationDays,
          paymentTerms: res.shopData.paymentTerms,
          paymentMilestones: res.shopData.paymentMilestones,
          qty: 1,
          currency: vm.info.currency,
          onlyDP: function () {
            return false;
          },
        };

        vm.due.dueNow = _.find(res.paymentMilestonesData, {
          isDueNow: true,
        });

        vm.due.paymentSchedule = _.filter(res.paymentMilestonesData, {
          isDueNow: false,
        });

        vm.totalDives = vm.diversNumber.reduce(function (sum, val) {
          return sum + val.numberOfDives;
        }, 0);

        vm.groupedByDivesNumber = _(vm.diversNumber)
          .sortByOrder('numberOfDives')
          .groupBy('numberOfDives')
          .value();

        vm.totalOptionPrice = vm.selectedOptions.reduce(function (sum, val) {
          if (val.isInsurance) {
            return sum + ($rootScope.setValue(val.priceGross, val.currency, true, vm.optionsCurrency) * val.qty);
          }
          return sum + (val.priceGross * val.qty);
        }, 0);

        vm.totalOptionPriceWithoutInsurance = vm.selectedOptions.reduce(function (sum, val) {
          if (val.isInsurance) {
            return sum;
          }
          return sum + (val.priceGross * val.qty);
        }, 0);

        if (currentDO.resortKind === 10) {
          vm.totalOptionTaxes = vm.totalOptionPriceWithoutInsurance * (vm.due.taxPercent / 100);
        } else {
          var priceForTransfers = vm.selectedOptions.reduce(function (sum, val) {
            if (val.isCourse || val.isInsurance) {
              return sum;
            }
            return sum + (val.priceGross * val.qty);
          }, 0);

          vm.totalOptionTaxes = priceForTransfers * (vm.due.taxPercent / 100);
        }

        vm.mandatorySurchargesTaxes = vm.mandatorySurchargesGrossPrice * (vm.due.taxPercent / 100);
        vm.mandatorySurchargesPrice = vm.mandatorySurchargesGrossPrice;

        vm.packagePrices = roomPrice + vm.divesPrices;
        vm.packagePricesTaxes =  vm.packagePrices * (vm.due.taxPercent / 100);
        vm.selectedOptionsGrouped = _.map(_.groupBy(vm.selectedOptions, 'pricingId'));

        vm.itemsIncluded = [];
        vm.itemsMandatory = [];
        vm.itemsExtra = [];
        vm.freeInsurance;

        vm.itemsMandatoryTotal = 0;
        vm.itemsExtraTotal = 0;
        vm.itemsExtraLegend = false;
        vm.itemsMandatoryLegend = false;


        _.each(vm.selectedOptionsGrouped, function (val) {
          val[0].totalPrice = 0;
          val[0].totalQty = 0;

          _.each(val, function (v) {
            val[0].totalPrice += v.priceGross * v.qty;
            val[0].totalQty += v.qty;
          }, 0);

          if (val[0].isIncluded) {
            if (val[0].isInsurance) {
              vm.freeInsurance = val[0];
            } else {
              vm.itemsIncluded.push(val[0]);
            }
          } else if (val[0].isMandatory) {
            vm.itemsMandatory.push(val[0]);

            if (val[0].payedInAdvance) {
              vm.itemsMandatoryTotal += val[0].totalPrice;
            } else {
              vm.itemsMandatoryLegend = true;
            }
          } else {
            vm.itemsExtra.push(val[0]);

            if (val[0].payedInAdvance || val[0].isCourse || val[0].isInsurance) {
              vm.itemsExtraTotal += val[0].totalPrice;
            } else {
              vm.itemsExtraLegend = true;
            }
          }
        });

        vm.order.roomPrice += mandatoryItemsPrice;

        if (!vm.order.roomParams.details) {
          vm.groupedRooms = {1: [{
            occupancy: vm.order.roomParams.divers + vm.order.roomParams.nonDivers + vm.order.roomParams.students,
            rooms: 1,
            index: 1,
          }]};
        } else {
          vm.groupedRooms = _(vm.order.roomParams.details)
            .each(function (val, i) {
              val.occupancy = val.divers + val.nonDivers + val.students;
              val.index = i + 1;
            })
            .groupBy('occupancy')
            .value();
        }


        vm.step = 3;
        vm.loader = false;

        var str = ', ';

        if (vm.diversNumber) {
          str += vm.diversNumber.length + ' diver(s)';
        }

        if (vm.nonDiversNumber && vm.nonDiversNumber.length) {
          str += ', ' + vm.nonDiversNumber.length + ' non-diver(s)';
        }

        ecomerceProduct = {
          variant: vm.order.roomTitle + ', ' + vm.order.rate.title + str,
          id: vm.info.id,
          price: $rootScope.setValue(vm.due.amountTotal, vm.info.currency, true, 'USD'),
          name: vm.info.title,
          brand: 'Independent',
          category: 'Dive Resort',
          quantity: 1,
        };

        GTM.variables({'checkout_cart_value': ecomerceProduct.price});

        GTM.products('checkout_step_review', {
          'checkout': {
            'actionField': {
              'step': 'Review',
            },
            'products': [ecomerceProduct],
          },
        });

        // last minute bookings;
        // show payment form only if trip starts earlier than 21 days from today

        if ( vm.isLastMinuteBooking(vm.order.from) ) {
          vm.showPaymentForm = true;
          vm.isLastMinute = true;
          if (vm.paymentProcessor === paymentService.STRIPE_PP) {
            paymentService.initStripe();
          } else if (vm.paymentProcessor === paymentService.ADYEN_PP) {
            paymentService.initAdyen();
          }
        } else {
          if (vm.experimentIsActive) {
            paymentService.initStripe();
          }
          vm.showPaymentForm = false;
          vm.isLastMinute = false;
        }
      }).catch(function (error) {
        if (error && error.data) {
          var errors = _.map(error.data);
          if (errors.length) {
            $rootScope.showNotify(errors[0], 7000);
          }
          vm.loader = false;
        }
      });
    }

    function checkout(form) {
      form.$setSubmitted();

      if ((form.$valid && vm.order.accepted) || vm.orderEdit) {
        vm.loader = true;

        vm.usdTotalPrice =  $rootScope.setValue(vm.due.amountTotal, vm.info.currency, true, 'USD');
        if (vm.orderEdit) {
          setStaffOrder();

          vm.loader = true;
          return checkoutService.staffUpdate(vm.order).then(function (data) {
            localStorageService.remove('order_uuid');
            localStorageService.remove('referrer');

            if (data.isPaymentsEdited || data.isSupplierPaymentsEdited) {
              vm.isPaymentsEdited = data.isPaymentsEdited;
              vm.isSupplierPaymentsEdited = data.isSupplierPaymentsEdited;

              return (vm.step = 'payment-issue');
            }

            GTM.variables({
              checkout_order_id: data.reference,
              user_email_md5: vm.order.email && utils.md5(vm.order.email),
              checkout_order_amount: vm.usdTotalPrice,
            });

            GTM.products('checkout_complete', {
              'purchase': {
                'actionField': {
                  'id': data.reference,
                  'affiliation': data.affiliateId ? 'Affiliate: ' + data.affiliateId : 'Diviac',
                  'revenue': vm.usdTotalPrice,
                },
                products: [ecomerceProduct],
              },
            });

            $window.location.href = vm.order.referrer;
          })
            .catch(function (error) {
              if (error.data.nonFieldErrors) {
                $rootScope.showNotify(error.data.nonFieldErrors[0]);
              } else {
                $rootScope.showNotify(gettextCatalog.getString('Something went wrong'));
              }
            })
            .finally(function () {
              vm.loader = false;
            });
        }

        form.$submitted = true;

        if (form.$invalid) {
          return false;
        }

        if (vm.showPaymentForm || vm.experimentIsActive) {
          // bradcasting createSource event to isolated payment directive;
          // payment validation happen there;
          // callback will be saveOrder() function;
          $rootScope.$broadcast('createSource');
        } else {
          saveOrder({source: false});
        }
      }
    }

    function saveOrder(response) {
      var errorMessage = $('.error-msg');

      if (response.noMethod) {
        if (Auth.isStaff() || Auth.isAffiliate()) {
          // payment info is optional for staff so pass them through if they haven't touched payment form;
          saveOrder({source: false});
          return;
        }
        // otherwise force user to choose payment method;
        $rootScope.showNotify(gettextCatalog.getString('You must select a payment method to proceed.'));
        $rootScope.scrollTo('#payment');
        vm.loader = false;
        return;
      } else if (response.error || response.errorCode) {
        vm.loader = false;
        errorMessage.text(response.error.message);
        errorMessage.addClass('visible');
        $rootScope.scrollTo('.payment-methods-list');
        return;
      }

      // add payment response to order
      if (vm.showPaymentForm || vm.experimentIsActive) {
        if (vm.paymentProcessor === paymentService.STRIPE_PP) {
          vm.order.stripeSourceId = response.source ? response.source.id : undefined;
        } else if (vm.paymentProcessor === paymentService.ADYEN_PP) {
          vm.order.adyenPaymentData = response || undefined;
        }
        vm.order.paymentProcessor = vm.paymentProcessor;

        // for redirect payment types we just store payment type for user;
        if (response.isRedirect) {
          delete vm.order.paymentProcessor;
          vm.order.redirectPaymentMethodType = response.paymentMethodValue;
        }
      }

      if (Auth.isStaff() || Auth.isAffiliate()) {
        // Staff or Affiliate order

        setStaffOrder();
        vm.loader = true;

        if (vm.isNewOption && Auth.isStaff()) {
          vm.order.parentOrderReference = vm.isNewOption;
          vm.order.isTeamOption = true;

          sessionStorage.removeItem('newOption');
        }

        checkoutService.staffCheckout(vm.order).then(function (data) {
          GTM.variables({
            checkout_order_id: data.reference,
            'user_email_md5': vm.order.email && utils.md5(vm.order.email),
            checkout_order_amount: vm.usdTotalPrice,
          });

          GTM.products('checkout_complete', {
            'purchase': {
              'actionField': {
                'id': data.reference,
                'affiliation': data.affiliateId ? 'Affiliate: ' + data.affiliateId : 'Diviac',
                'revenue': vm.usdTotalPrice,
              },
              products: [ecomerceProduct],
            },
          });

          setPageAfterCheckout(data);
        })
          .catch(function (error) {
            vm.success = false;
            if (error.data.nonFieldErrors) {
              errorMessage.text(error.data.nonFieldErrors[0]);
              errorMessage.addClass('visible');
            }
          })
          .finally(function () {
            vm.loader = false;
          });
      } else {
        // Common order
        $rootScope.scrollTo('.complete-wrap');
        // if (displayError) displayError.innerHTML = '';
        vm.order.dateTo = moment(vm.order.to).format('YYYY-MM-DDThh:mm');
        vm.order.dateFrom = moment(vm.order.from).format('YYYY-MM-DDThh:mm');
        vm.order.source = utils.getSource();
        vm.order.userCurrency = $rootScope.currency;

        if (affiliate) {
          vm.order.affiliateId = affiliate.aid;
          vm.order.affiliateCampaign = affiliate.cid;
        }

        if (!vm.showPaymentForm && vm.experimentId) {
          vm.order.gaExperiment = vm.experimentId;
          vm.order.gaClientId = gaClientId;
        }

        checkoutService.checkout(vm.order).then(function (data) {
          vm.orderId = data.id;
          vm.order.card = null;

          vm.order.reference = data.reference;

          GTM.variables({
            checkout_order_id: data.reference,
            user_email_md5: utils.md5(vm.order.email),
            checkout_order_amount: vm.usdTotalPrice,
          });

          GTM.products('checkout_complete', {
            'purchase': {
              'actionField': {
                'id': data.reference,
                'affiliation': data.affiliateId ? 'Affiliate: ' + data.affiliateId : 'Diviac',
                'revenue': vm.usdTotalPrice,
              },
              products: [ecomerceProduct],
            },
          });

          setPageAfterCheckout(data);

          $rootScope.scrollTo('.checkout-page');
        }).catch(function (error) {
          vm.loader = false;
          vm.success = false;
          if (error.data.nonFieldErrors) {
            errorMessage.text(error.data.nonFieldErrors[0]);
            errorMessage.addClass('visible');
          }
        });
      }
    }

    function createAccount(form) {
      form.$setSubmitted();

      if (form.$valid) {
        vm.reg.password2 = vm.reg.password;
        vm.reg.firstName = vm.order.firstName;
        vm.reg.lastName = vm.order.lastName;
        vm.reg.email = vm.order.email;
        vm.reg.orderId = vm.orderId;

        $rootScope.oldState = false;
        Auth.registration(vm.reg).catch(function (error) {
          if (error) {
            $rootScope.showNotify(error[0]);
          }
        });
      }
    }

    function saveOrderToStorage() {
      vm.order.сard = undefined;

      diviacLocalStorage.set('drOrder', {
        order: vm.order,
        diversNumber: vm.diversNumber,
        selectedOptions: vm.selectedOptions,
        roomPrice: roomPrice,
        divesPrices: vm.divesPrices,
      });

      $rootScope.toState = window.location.pathname;
    }

    function setStaffOrder() {
      $rootScope.scrollTo('.complete-wrap');
      vm.order.shop = vm.info.id;
      vm.order.dateTo = moment(vm.order.to).format('YYYY-MM-DDThh:mm');
      vm.order.dateFrom = moment(vm.order.from).format('YYYY-MM-DDThh:mm');
      if (affiliate && Auth.isAffiliate()) {
        vm.order.affiliateId = affiliate.aid;
        vm.order.affiliateCampaign = affiliate.cid
      }
    }

    function setUserAccount(account) {
      vm.order.account = account ? account.id : null;
      vm.userPaymentMethod = null;
      paymentService.getUserCC(account.id).then(function (data) {
        vm.userPaymentMethod = data;
      });
    }

    function stepChanged(step) {
      if (vm.step > step) {
        if (step === 1) {
          firstStepOpen();
        } else {
          vm.step = step;
        }
        // onStepChange();
      }

      if (step < 3) {
        paymentService.destroyElements();
        vm.dataForDueNow = false;
        console.log('stepchanged');
        // vm.paymentMethod = null;
      }
    }

    function setPageAfterCheckout(data) {
      if (Auth.isStaff()) {
        var link;

        if (utils.isDev) {
          link = 'https://intranet.diviac.inprogress.rocks/booking-list';
        } else {
          link = 'https://intranet.diviac.com/booking-list';
        }

        window.location.href = link + '?order_id=' + data.id + '&tab=Internal';
      } else {
        vm.step = 4;
        vm.loader = false;
      }
    }

    function updateUserCredentials() {
      angular.extend(vm.order, paymentService.prefillUser());
    }

    function applyVoucher() {
      if (vm.voucherCode && vm.voucherCode.length) {
        vm.loader = true;
        checkoutService.validateVoucher(vm.voucherCode).then(function (result) {
          vm.loader = false;
          vm.appliedVoucher = result;
          vm.voucherCode = '';
          vm.showCouponForm = false;
          createOrder();
        }).catch(function (err) {
          vm.discountError = _.get(err.data, 'code[0]');
          vm.loader = false;
        });
      }
    }

    function removeVoucher() {
      vm.appliedVoucher = false;
      createOrder();
      $rootScope.showNotify('Discount was removed');
    }
  });
